module.exports = __webpack_public_path__ + "img/index.24cbbbc6.png";